import * as React from 'react';
import { legacyCardDriverFactory } from './LegacyCard.driver';
import { LegacyCard, LegacyCardRatioOptions } from '.';
import { TPAComponentsProvider } from '../TPAComponentsConfig';
import { createRendererWithUniDriver } from '../../test/utils';

describe('LegacyCard', () => {
  const render = createRendererWithUniDriver(legacyCardDriverFactory);

  it('should render info', async () => {
    const textContent = 'info!';
    const value = <div>{textContent}</div>;
    const { driver } = render(<LegacyCard info={value} />);
    expect((await driver.getInfoContent()).textContent).toEqual(textContent);
  });

  it('should render image', async () => {
    const textContent = 'image!';
    const value = <div>{textContent}</div>;
    const { driver } = render(<LegacyCard media={value} />);
    expect((await driver.getMediaContent()).textContent).toEqual(textContent);
  });

  it('should render ratio 50 as default', async () => {
    const { driver } = render(<LegacyCard info="info" media="media" />);
    expect(await driver.getRatio()).toEqual(LegacyCardRatioOptions.RATIO_50_50);
  });

  it('should render ratio 40', async () => {
    const { driver } = render(
      <LegacyCard
        ratio={LegacyCardRatioOptions.RATIO_40_60}
        info="info"
        media="media"
      />,
    );
    expect(await driver.getRatio()).toEqual(LegacyCardRatioOptions.RATIO_40_60);
  });

  it('should render ratio 30', async () => {
    const { driver } = render(
      <LegacyCard
        ratio={LegacyCardRatioOptions.RATIO_30_70}
        info="info"
        media="media"
      />,
    );
    expect(await driver.getRatio()).toEqual(LegacyCardRatioOptions.RATIO_30_70);
  });

  it('should render ratio 100 if there is no media', async () => {
    const { driver } = render(<LegacyCard info="info" />);
    expect(await driver.getRatio()).toEqual(LegacyCardRatioOptions.RATIO_100);
  });

  it('should flipped the ratio', async () => {
    const { driver } = render(<LegacyCard flippedRatio />);
    expect(await driver.isFlippedRatio()).toEqual(true);
  });

  it('should invert the image position', async () => {
    const { driver } = render(<LegacyCard invertInfoPosition />);
    expect(await driver.isImagePositionInverted()).toEqual(true);
  });

  it('should use mobile design', async () => {
    const { driver } = render(
      <TPAComponentsProvider value={{ mobile: true }}>
        <LegacyCard invertInfoPosition data-hook="legacy-card" />
      </TPAComponentsProvider>,
      'legacy-card',
    );

    expect(await driver.isMobile()).toEqual(true);
  });
});
